import React from "react";

const ContactMap = () => {
  return (
    <div >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.9304259975565!2d80.161811673485!3d13.103594011973897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526637d48f0e83%3A0x7af736c1b14f967c!2sAswin%20Cold%20Forge%20Private%20Limited!5e0!3m2!1sen!2sin!4v1736777099121!5m2!1sen!2sin"
        width="100%"
        height="100%"
        className="lg:h-full md:h-80 sm:h-80 max-sm:h-80"
        style={{border:0}}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default ContactMap;
